import {createTheme} from "@mui/material";

export const theme = createTheme({
    palette: {
        primary: {
            main: '#2c96ff',
        },
        secondary: {
            main: '#ff00a4',
        },
        success: {
            main: '#00e500',
        },
    },
});